import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useQuoteRequestState } from "../hooks/useAnalysisState";

interface QuoteRequestGuardProps {
  children: React.ReactNode;
}

const QuoteRequestGuard: React.FC<QuoteRequestGuardProps> = ({ children }) => {
  const navigate = useNavigate();
  const { requestId, isLoading } = useQuoteRequestState();

  useEffect(() => {
    if (!isLoading && requestId) {
      navigate("/rate-results");
    }
  }, [requestId, isLoading, navigate]);

  if (isLoading) {
    return (
      <div className="py-12 px-4">
        <div className="container-custom">
          <div className="max-w-4xl mx-auto text-center">
            <div className="animate-pulse">
              <div className="h-8 bg-gray-200 rounded w-1/3 mx-auto mb-4"></div>
              <div className="h-4 bg-gray-200 rounded w-1/2 mx-auto"></div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return <>{children}</>;
};

export default QuoteRequestGuard;
